<template>
    <CHeader fixed with-subheader light>
        <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
        <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
        <CHeaderNav>
            <CHeaderNavItem class="px-3">
                {{$store.state.user_name}} خوش آمدید
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderBrand class="mx-auto d-lg-none">
            <CIcon name="" height="48" alt="" />
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
            <!-- <CHeaderNavItem class="d-md-down-none mx-2">
                <CHeaderNavLink to="/support">
                    <CIcon name="cil-envelope-closed"/> پیام‌های دریافتی
                    <CBadge color="danger" position="top-start" shape="rounded-pill">
                        {{counter}}
                    </CBadge>
                </CHeaderNavLink>
            </CHeaderNavItem> -->
            <CHeaderNavItem class="d-md-down-none mx-2">
                <CHeaderNavLink to="/docs">
                    <CIcon name="cil-code"/> مستندات
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="d-md-down-none mx-2"
                v-show="this.$store.state.perms.can_view_user_logs_over_ws
                    || this.$store.state.perms.can_view_same_user_groups_logs_over_ws
                    || this.$store.state.perms.can_view_all_user_logs_over_ws">
                <CHeaderNavLink to="/notifications">
                    <CIcon name="cil-bell"/> نوتیفیکیشن  <CBadge color="danger">{{$store.state.alert}}</CBadge>
                </CHeaderNavLink>
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav class="mr-4">
            <TheHeaderDropdownAccnt/>
        </CHeaderNav>
        <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
    </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
export default {
    components: {
        TheHeaderDropdownAccnt
    },
    // data(){
    //     return{
    //         counter: 0
    //     }
    // },
    // mounted(){
    //     this.axios.get('conversations/'
    //         + '?is_active=true')
    //         .then(res => {
    //             res.data.map(val => {
    //                 if(val.is_active == true){
    //                     if(val.is_answered == false){
    //                         this.counter += 1;
    //                     }
    //                 }
    //             });
    //         })
    // }
}
</script>